import { Component } from '@angular/core';
import { PageNames } from 'src/app/configs/page-names.enum';

import { BasePageComponent } from 'src/app/pages/shared/base/components/base-page.component';

@Component({
    selector: 'app-reseller-send-queue',
    templateUrl: './reseller-send-queue.component.html',
    standalone: false
})
export class ResellerSendQueueComponent extends BasePageComponent {
  //#region Properties

  getTableDataApiMethodName: string =
    'scheduledMessagesGetResellerScheduledMessageWithPagination';
  pageTitle: string = 'pages.sendQueue.resellerTitle';
  tabName = PageNames.resellerSendQueue;
  //#endregion
}
